import request from '@/plugins/request';

/**
 * 获取置顶新闻（只查询一个置顶的）
 * @returns {Promise} - 返回Promise对象
 */
export function getTopNews() {
  return request({
    url: '/fronted/news/getTop',
    method: 'get'
  });
}

/**
 * 获取新闻列表（分页）
 * @param {Object} params - 请求参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise} - 返回Promise对象
 */
export function getNewsList(params) {
  return request({
    url: '/fronted/news/list',
    method: 'get',
    params
  });
}

/**
 * 获取新闻详情
 * @param {string|number} id - 新闻ID
 * @returns {Promise} - 返回Promise对象
 */
export function getNewsDetail(id) {
  return request({
    url: `/fronted/news/${id}`,
    method: 'get'
  });
}
